import { useAircall } from 'context/aircall';
import { useAuth } from 'context/auth';
import CallIntegrationType from 'crono-fe-common/types/enums/callIntegrationType';
import aircallLogo from 'assets/images/Icon_Aircall.svg';
import { CallFloatingUIBase } from 'components/CallFloatingUIBase';

export const AIRCALL_UI_CONTAINER_ID = 'crono-aircall-ui-container';

export const AircallCallFloatingUI = () => {
  const { closeFloatingUI, isFloatingUIVisible, isCallActive } = useAircall();
  const { user } = useAuth();

  if (!user || user.callIntegrationType !== CallIntegrationType.AIRCALL) {
    return null;
  }

  return (
    <CallFloatingUIBase
      logo={aircallLogo}
      logoAlt="aircall logo"
      title="Aircall"
      containerId={AIRCALL_UI_CONTAINER_ID}
      isFloatingUIVisible={isFloatingUIVisible}
      isCallActive={isCallActive}
      closeFloatingUI={closeFloatingUI}
    />
  );
};
